import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';

import {StreamConfigurationsService} from '../../../services/api/stream-configurations/stream-configurations.service';
import {
  loadStreamConfigurations,
  loadStreamConfigurationsFailure,
  loadStreamConfigurationsSuccess
} from './stream-configurations.load-all.actions';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';


@Injectable()
export class StreamConfigurationsLoadAllEffects {

  // noinspection JSUnusedGlobalSymbols
  loadStreamConfigurations$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadStreamConfigurations),
        concatMap(() => {
            return this.service.getAll()
              .pipe(
                map((data: StreamConfiguration[]) => loadStreamConfigurationsSuccess({data})),
                catchError((error: unknown) => of(loadStreamConfigurationsFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: StreamConfigurationsService
  ) {
  }

}
